const successfully_ATC_Timing = 4000;

document.addEventListener("DOMContentLoaded", function () {
    function updateSelectVariant() {
        var option1 = document.querySelector('[data-product-option-index="1"] [type="radio"]:checked')?.value || document.querySelector('[data-product-option-index="1"] select')?.value;
        var option2 = document.querySelector('[data-product-option-index="2"] [type="radio"]:checked')?.value || document.querySelector('[data-product-option-index="2"] select')?.value;
        var option3 = document.querySelector('[data-product-option-index="3"] [type="radio"]:checked')?.value || document.querySelector('[data-product-option-index="3"] select')?.value;

        var selectVariant = [option1, option2, option3].filter(Boolean).join(" / ");

        var selectBox = document.getElementById("product-variants-select");
        if (!selectBox) return;

        var options = selectBox.querySelectorAll("option");
        var variantFound = false;

        options.forEach(function (option) {
            if (option.getAttribute("data-val") === selectVariant) {
                variantFound = true;
                var variantId = option.value;
                selectBox.value = variantId;

                // Update product form hidden inputs
                document.querySelectorAll('.product-form input[name="id"]').forEach(input => {
                    input.value = variantId;
                });

                // Update sticky sidebar variant name
                var sidebar_sticky = document.querySelector(".detail__sidebar__sticky");
                if (sidebar_sticky) {
                    var sidebarVariant = sidebar_sticky.querySelector(".detail__sidebar__sticky__cta__content div p");
                    if (sidebarVariant) sidebarVariant.textContent = option.getAttribute("data-val");
                }

                // Update Add to Cart button
                var addToCartButton = document.querySelector('.product-form button[type="submit"]');
                var stickyAddToCartButton = document.querySelector('.detail__sidebar__sticky .product-form button[type="submit"]');

                if (option.getAttribute("data-variant-available") === "true") {
                    addToCartButton.textContent = "Add to Cart";
                    addToCartButton.disabled = false;
                    stickyAddToCartButton.textContent = "Add to Cart";
                    stickyAddToCartButton.disabled = false;
                } else {
                    addToCartButton.textContent = "Sold Out";
                    addToCartButton.disabled = true;
                    stickyAddToCartButton.textContent = "Sold Out";
                    stickyAddToCartButton.disabled = true;
                }

                // Update URL
                var newUrl = window.location.origin + window.location.pathname + "?variant=" + variantId;
                window.history.replaceState(null, "", newUrl);
            }
        });

        if (!variantFound) {
            var addToCartButton = document.querySelector('.product-form button[type="submit"]');
            var stickyAddToCartButton = document.querySelector('.detail__sidebar__sticky .product-form button[type="submit"]');

            if (addToCartButton) {
                addToCartButton.textContent = "Unavailable";
                addToCartButton.disabled = true;
                stickyAddToCartButton.textContent = "Unavailable";
                stickyAddToCartButton.disabled = true;
            }
        }
    }

    function updateSelectedOptionText(event) {
        var selectedText = event.target.closest(".purchase-cta")?.querySelector(".selected-option");
        if (selectedText) {
            selectedText.textContent = event.target.value;
        }
    }

    // Attach event listeners to variant selectors
    document.querySelectorAll("[data-product-option-index]").forEach(element => {
        element.addEventListener("change", function (event) {
            updateSelectVariant();
            updateSelectedOptionText(event);
        });
    });

    // Ensure the correct variant is selected on page load
    updateSelectVariant();

    // My details page JS
    const genderSelect = document.getElementById("gender");
    const cupSizeGroup = document.getElementById("cup-size-group");
    const form = document.getElementById("details-form");
    const successMessageDetails = document.getElementById("success-message-details");
    const shopifyStore = "marame-mcstaging.myshopify.com";
    const accessToken = "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";

    // Toggle cup size field based on gender selection
    if (cupSizeGroup) {
        function toggleCupSize() {
            cupSizeGroup.style.display = genderSelect.value === "male" ? "none" : "flex";
        }
        toggleCupSize();
        genderSelect.addEventListener("change", toggleCupSize);
    }
    if (form) {
        form.addEventListener("submit", saveCustomerDetails);
    }

    async function saveCustomerDetails(event) {
        event.preventDefault();
        const form = event.target;
        const customerId = form.getAttribute("data-customer-id");
        const metafields = [
            { namespace: "custom", key: "gender", value: document.getElementById("gender")?.value || "", type: "single_line_text_field" },
            { namespace: "custom", key: "size_tops", value: document.getElementById("size_tops")?.value || "", type: "single_line_text_field" },
            { namespace: "custom", key: "size_bottoms", value: document.getElementById("size_bottoms")?.value || "", type: "single_line_text_field" },
            { namespace: "custom", key: "cup_size", value: document.getElementById("cup_size")?.value || "", type: "single_line_text_field" },
            { namespace: "custom", key: "size_shoes", value: document.getElementById("size_shoes")?.value || "", type: "single_line_text_field" },
        ];

        try {
            await Promise.all(
                metafields.map(async metafield => {
                    const response = await fetch(`https://${shopifyStore}/admin/api/2023-10/customers/${customerId}/metafields.json`, {
                        method: "POST",
                        headers: {
                            "Content-Type": "application/json",
                            "X-Shopify-Access-Token": accessToken,
                        },
                        body: JSON.stringify({ metafield }),
                    });
                    const result = await response.json();
                    if (result.errors) {
                        console.error("Metafield update error:", result.errors);
                    }
                })
            );

            // Show success message dynamically
            successMessageDetails.innerText = "Your details have been saved successfully!";
            successMessageDetails.style.display = "block";

            // Hide success message after 5 seconds
            setTimeout(() => {
                successMessageDetails.style.display = "none";
            }, 5000);
        } catch (error) {
            console.error("Error updating metafields:", error);
        }
    }

    function initPasswordInputToggle() {
        const passwordFields = document.querySelectorAll(".field--password");

        passwordFields?.forEach(passwordField => {
            const passwordInput = passwordField?.querySelector("input");
            const passwordToggle = passwordField?.querySelector(".password-toggle");

            if (!passwordInput || !passwordToggle) return;

            passwordToggle?.addEventListener("click", function () {
                if (passwordInput.type === "password") {
                    passwordInput.type = "text";
                    passwordToggle.classList.add("hide-password");
                } else {
                    passwordInput.type = "password";
                    passwordToggle.classList.remove("hide-password");
                }
            });
        });
    }

    initPasswordInputToggle();

    function initOrderHistoryTableArrowToggle() {
        const orderHistoryMblArrowBtns = document.querySelectorAll(".order-history tbody .mbl-arrow");

        orderHistoryMblArrowBtns?.forEach(btn => {
            btn?.addEventListener("click", function () {
                this.classList.toggle("active");

                const parentRow = this.parentElement;

                const cells = Array.from(parentRow.cells);

                const clickedIndex = cells.indexOf(this);

                for (let i = clickedIndex + 1; i < cells.length; i++) {
                    cells[i].classList.toggle("active");
                }
            });
        });
    }

    initOrderHistoryTableArrowToggle();
});

// CWI CODE N
function product_grid_size_option() {
    document.querySelectorAll(".product--grid--main .size-select__options .option").forEach(function (single_size_option) {
        single_size_option.addEventListener("click", function () {
            var gridVariantID = parseInt(this.getAttribute("data_variant_id"));
            this.closest(".product--grid--main").querySelector("form.form input[name='id']").value = gridVariantID;
            this.closest(".product--grid--main").querySelector(".atc_JS").removeAttribute("disabled");
            if (this.closest(".product--grid--main").querySelector(".atc_JS small")) {
                if (this.classList.contains("option--out-of-stock")) {
                    this.closest(".product--grid--main").querySelector(".atc_JS small").innerHTML = window.variantStrings.notify_btn_text;
                } else {
                    // this.closest(".product--grid--main").querySelector(".atc_JS small").innerHTML = window.variantStrings.quick_ATC_text;
                    this.closest(".product--grid--main").querySelector(".atc_JS small").innerHTML = window.variantStrings.addToCart;
                }
            }
        });
    });

    document.querySelectorAll(".product--grid--main .size_option_not_available button").forEach(function (size_option_not_available_btn) {
        size_option_not_available_btn.addEventListener("click", function () {
            this.closest(".product--grid--main").querySelector(".atc_JS").click();
        });
    });

    setTimeout(function () {
        document.querySelectorAll(".lookbook-product__content__details__item__sizes .size-select__options").forEach(function (single_size_options) {
            if (single_size_options.querySelector(".option:not(.option--out-of-stock)")) {
                single_size_options.querySelector(".option:not(.option--out-of-stock)").click();
            }
        });
    }, 100);
}

function product_grid_ATC() {
    document.querySelectorAll(".product--grid--main .atc_JS").forEach(function (atc_JS) {
        atc_JS.addEventListener("click", function (event) {
            event.preventDefault();

            if (this.closest(".product--grid--main").querySelector(".size-select__options.product_not_available") || this.closest(".product--grid--main").querySelector(".size-select__options .option.option--out-of-stock.active")) {
                if (this.closest(".product--grid--main").querySelector("form.form .klaviyo-bis-trigger")) {
                    this.closest(".product--grid--main").querySelector("form.form .klaviyo-bis-trigger").click();
                }
            } else {
                if (!this.hasAttribute("disabled")) {
                    if (this.closest(".product--grid--main").querySelector(".size-select__options .option.option--out-of-stock.active")) {
                        return;
                    }
                    var form = this.closest(".product--grid--main").querySelector("form.form");
                    if (!form) return;
                    cart_add_fetch(form);
                } else {
                    if (this.closest(".product--grid--main").querySelector(".size-select__options .option")) {
                        var successfullyATC = this.closest(".product--grid--main").querySelector(".successfully_ATC");
                        if (successfullyATC) {
                            successfullyATC.innerHTML = "SELECT SIZE";
                            setTimeout(() => {
                                successfullyATC.innerHTML = "";
                            }, successfully_ATC_Timing);
                        }
                    }
                }
            }
        });
    });
}

function check_size_option() {
    setTimeout(() => {
        document.querySelectorAll(".product--grid--main .size-select__options").forEach(function (options_wrapper) {
            if (!options_wrapper.querySelector(".option")) {
                options_wrapper.closest(".product--grid--main").querySelector(".atc_JS").removeAttribute("disabled");
            }
            if (options_wrapper.querySelector(".option.active")) {
                options_wrapper.closest(".product--grid--main").querySelector(".atc_JS").setAttribute("disabled", true);
                options_wrapper.closest(".product--grid--main").querySelector(".option").classList.remove("active");
            }
        });
    }, 500);
}

check_size_option();

function cart_add_fetch(form) {
    var formData = new FormData(form);

    fetch("/cart/add.js", {
        method: "POST",
        body: formData,
    })
        .then(response => {
            return response.json();
        })
        .then(response => {
            fetch(window.Shopify.routes.root + "cart.js", {
                method: "GET",
            })
                .then(cart => {
                    return cart.json();
                })
                .then(cartjson => {
                    var cart_item_count = cartjson.item_count;
                    if (document.querySelector("header.header .header__right__bag .header__right__bag__cart")) {
                        document.querySelector("header.header .header__right__bag .header__right__bag__cart").innerHTML = cart_item_count;
                    }
                    cart_popup_notification();
                    atc_added_check();
                })
                .catch(error => {
                    console.error("Error:", error);
                });

            if (form.closest(".product--grid--main")) {
                var successfullyATC = form.closest(".product--grid--main").querySelector(".successfully_ATC");
            }
            if (form.closest(".detail__sidebar__content")) {
                var successfullyATC = form.closest(".detail__sidebar__content").querySelector(".successfully_ATC");
            }

            if (successfullyATC) {
                successfullyATC.innerHTML = "ITEM ADDED TO CART";
                setTimeout(() => {
                    successfullyATC.innerHTML = "";
                }, successfully_ATC_Timing);
            }
        })
        .catch(error => {
            console.error("Error:", error);
            if (form.closest(".product--grid--main")) {
                var successfullyATC = form.closest(".product--grid--main").querySelector(".successfully_ATC");
            }
            if (form.closest(".detail__sidebar__content")) {
                var successfullyATC = form.closest(".detail__sidebar__content").querySelector(".successfully_ATC");
            }
            if (successfullyATC) {
                successfullyATC.innerHTML = "ITEM NOT ADDED TO CART";
                setTimeout(() => {
                    successfullyATC.innerHTML = "";
                }, successfully_ATC_Timing);
            }
        });
}

function cart_popup_notification() {
    if (document.querySelector("header.header .header__right__bag .header__right__bag__list")) {
        fetch(window.location.href)
            .then(response => {
                return response.text();
            })
            .then(responseData => {
                var parser = new DOMParser(),
                    new_sortBy_HTML = parser.parseFromString(responseData, "text/html"),
                    fetchNewHTML = new_sortBy_HTML.querySelector("header.header .header__right__bag .header__right__bag__list").innerHTML;

                document.querySelector("header.header .header__right__bag .header__right__bag__list").innerHTML = fetchNewHTML;

                document.querySelector("header.header .header__right__bag").classList.add("active");
                setTimeout(() => {
                    document.querySelector("header.header .header__right__bag").classList.remove("active");
                }, 2500);
            })
            .catch(error => {
                console.error("Fetch error:", error);
            });
    }
}

function product_variant_default() {
    if (document.querySelector("body.product .shopify-product-form .product_option_selection")) {
        var getProductJSON = JSON.parse(document.querySelector("body.product .shopify-product-form script").innerHTML),
            option_selector_ID = document.querySelector("body.product .shopify-product-form .product_option_selection").getAttribute("id");

        var selectCallback = function (variant, selector) {
            // console.log("variant: ",variant);
            // console.log("selector: ",selector);

            if (variant.featured_media != null) {
                if (document.querySelector(".product .detail__sliders__main-slider.swiper-initialized .swiper-slide[media_id='" + variant.featured_media.id + "']")) {
                    var swiper_index = parseInt(document.querySelector(".product .detail__sliders__main-slider .swiper-slide[media_id='" + variant.featured_media.id + "']").getAttribute("data-swiper-slide-index"));
                    document.querySelector(".product .detail__sliders__main-slider").swiper.slideTo(swiper_index);
                }
            }

            var variant_price = Shopify.formatMoney(variant.price, document.querySelector("body").getAttribute("shop_moneyformat"));

            if (selector.variantIdField.closest(".detail__sidebar__content").querySelector(".detail__sidebar__colors__price h4")) {
                selector.variantIdField
                    .closest(".detail__sidebar__content")
                    .querySelectorAll(".detail__sidebar__colors__price h4")
                    .forEach(function (price_element) {
                        price_element.innerHTML = variant_price;
                    });
            }

            if (variant.available) {
                selector.variantIdField.closest(".detail__sidebar__content").querySelector(".addtocart_form_submit").innerHTML = window.variantStrings.addToCart;
                selector.variantIdField.closest(".detail__sidebar__content").querySelector(".addtocart_form_submit").classList.remove("disabled");
            } else {
                selector.variantIdField.closest(".detail__sidebar__content").querySelector(".addtocart_form_submit").innerHTML = window.variantStrings.notify_btn_text;
                selector.variantIdField.closest(".detail__sidebar__content").querySelector(".addtocart_form_submit").classList.add("disabled");
            }
        };

        new Shopify.OptionSelectors(option_selector_ID, {
            product: getProductJSON,
            onVariantSelected: selectCallback,
            enableHistoryState: true,
        });

        document.querySelectorAll("body.product .detail__sidebar__content .option").forEach(function (selected_option) {
            selected_option.addEventListener("click", function (event) {
                var selected_value = this.getAttribute("data-value"),
                    option_index = this.closest(".option_index").getAttribute("data-option"),
                    select_box = this.closest(".detail__sidebar__content").querySelector(".single-option-selector[data-option='" + option_index + "']");
                select_box.value = selected_value;
                select_box.dispatchEvent(new Event("change"));
            });
        });

        document.querySelector("body.product .detail__sidebar__content .addtocart_form_submit").addEventListener("click", function (event) {
            event.preventDefault();
            if (this.classList.contains("disabled") && this.closest(".detail__sidebar__content").querySelector("form.shopify-product-form .klaviyo-bis-trigger")) {
                this.closest(".detail__sidebar__content").querySelector("form.shopify-product-form .klaviyo-bis-trigger").click();
            } else {
                if (this.closest(".detail__sidebar__content").querySelector(".detail__sidebar__sizes .size-select__options")) {
                    if (!this.closest(".detail__sidebar__content").querySelector(".detail__sidebar__sizes .size-select__options .option.active")) {
                        var successfullyATC = this.closest(".detail__sidebar__content").querySelector(".successfully_ATC");
                        if (successfullyATC) {
                            successfullyATC.innerHTML = "SELECT SIZE";
                            setTimeout(() => {
                                successfullyATC.innerHTML = "";
                            }, successfully_ATC_Timing);
                        }
                        return;
                    }
                }
            }
            if (!this.classList.contains("disabled")) {
                // this.closest(".detail__sidebar__content").querySelector("form.shopify-product-form").submit();

                var form = this.closest(".detail__sidebar__content").querySelector("form.form");
                if (!form) return;
                cart_add_fetch(form);
            }
        });
    }
}

product_variant_default();

window.addEventListener("load", event => {
    if (document.querySelector("#sort-by-collection-product")) {
        var urlParams = new URLSearchParams(window.location.search),
            sortBy = urlParams.get("sort_by");
        if (sortBy && document.querySelector("#sort-by-collection-product-ts-control div.item")) {
            var matchingOption = document.querySelector("#sort-by-collection-product option[data_sort='" + sortBy + "']").innerText;
            document.querySelector("#sort-by-collection-product-ts-control div.item").innerText = matchingOption;
        }
    }
});

if (document.querySelector("#sort-by-collection-product")) {
    document.querySelector("#sort-by-collection-product").addEventListener("change", function () {
        var selectedOption = this.options[this.selectedIndex],
            dataSortValue = selectedOption.getAttribute("data_sort"),
            url = new URL(window.location.href);

        url.searchParams.set("sort_by", dataSortValue);
        history.replaceState({}, "", url.toString());

        fetch(window.location.href)
            .then(response => {
                return response.text();
            })
            .then(responseData => {
                var parser = new DOMParser(),
                    new_sortBy_HTML = parser.parseFromString(responseData, "text/html"),
                    fetchNewHTML = new_sortBy_HTML.querySelector("#MainContent section.listing").innerHTML;

                document.querySelector("#MainContent section.listing").innerHTML = fetchNewHTML;

                load_listing_script();
                load_init_scripts_script();

                product_grid_size_option();
                product_grid_ATC();
                load_more_product_JS();
                iWish.init();
                product_media_update();
                check_size_option();
                grid_metafield_product();
                grid_option_controls();
            })
            .catch(error => {
                console.error("Fetch error:", error);
            });
    });
}

function collection_pro_filter() {
    const filterWrapper = document.querySelector(".filters__left__secondary");
    const comman_filter = document.querySelector(".filter-panels");

    if (comman_filter) {
        var filter_url = "",
            view_button = document.querySelectorAll("#main-view-button,#secondary-view-button"),
            clear_button = document.querySelectorAll("#main-clear-button,#secondary-clear-button");

        view_button.forEach(function (view_BTN) {
            view_BTN.addEventListener("click", function () {
                const selectedItems = this.closest(".filter-panels").querySelectorAll(".filter-panel__item.selected");
                if (selectedItems.length === 0) return;
                let url = new URL(window.location.href);
                selectedItems.forEach(function (item) {
                    const value = item.getAttribute("data-value");
                    if (value && value.includes("=")) {
                        const [param, val] = value.split("=");
                        url.searchParams.set(param, decodeURIComponent(val));
                    }
                });
                afterFilterApply(url);
            });
        });

        clear_button.forEach(function (clear_BTN) {
            clear_BTN.addEventListener("click", function () {
                const url = new URL(window.location.href);
                const initialURL = url.toString();
                url.search = "";
                if (url.toString() !== initialURL) {
                    afterFilterApply(url);
                }
            });
        });
    } else {
        if (!filterWrapper) return;

        filterWrapper.addEventListener("change", function (e) {
            const target = e.target;
            if (!target.classList.contains("filter")) return;

            const filters = filterWrapper.querySelectorAll(".filter");
            const url = new URL(window.location.href);

            filters.forEach(function (dropdown) {
                const val = dropdown.value;
                if (val && val.includes("=")) {
                    const [param] = val.split("=");
                    url.searchParams.delete(param);
                }
            });

            filters.forEach(function (dropdown) {
                const val = dropdown.value;
                if (val && val.includes("=")) {
                    const [param, value] = val.split("=");
                    if (param && value) {
                        url.searchParams.set(param, decodeURIComponent(value));
                    }
                }
            });
            afterFilterApply(url);
        });
    }
}

function afterFilterApply(url) {
    history.replaceState({}, "", url.toString());
    fetch(url.toString())
        .then(response => response.text())
        .then(responseData => {
            const parser = new DOMParser();
            const newHTML = parser.parseFromString(responseData, "text/html");
            const newSectionHTML = newHTML.querySelector("#MainContent section.listing")?.innerHTML;
            const newSectionFilterHTML = newHTML.querySelector("#MainContent section.listing .filter-panels")?.innerHTML;

            if (newSectionHTML || newSectionFilterHTML) {
                if (newSectionHTML) {
                    document.querySelector("#MainContent section.listing").innerHTML = newSectionHTML;
                }
                if (newSectionFilterHTML) {
                    document.querySelector("#MainContent section.listing .filter-panels").innerHTML = newSectionFilterHTML;
                }
                load_listing_script();
                load_init_scripts_script();
                product_grid_size_option();
                product_grid_ATC();
                load_more_product_JS();
                iWish.init();
                product_media_update();
                check_size_option();
                grid_metafield_product();
                grid_option_controls();
            }
        })
        .catch(error => {
            console.error("Filter fetch error:", error);
        });
}

collection_pro_filter();

function load_more_product_JS() {
    if (document.querySelector("#load_more_product_JS")) {
        document.querySelector("#load_more_product_JS").addEventListener("click", function () {
            var data_current_page = parseInt(this.getAttribute("data_current_page")),
                data_current_page = data_current_page + 1,
                data_next_page = this.getAttribute("data_next_page"),
                data_total_page = parseInt(this.getAttribute("data_total_page")),
                new_fetch_url = data_next_page.replace(/page=[0-9]+/, "page=" + data_current_page),
                new_fetch_url = new_fetch_url.split('&')[0];
          
            this.setAttribute("data_current_page", data_current_page);

            fetch(new_fetch_url)
                .then(response => {
                    return response.text();
                })
                .then(responseData => {
                    var parser = new DOMParser(),
                        new_loadmore_HTML = parser.parseFromString(responseData, "text/html"),
                        fetchNewHTML = new_loadmore_HTML.querySelector("#MainContent section.listing .listing__list").innerHTML;

                    document.querySelector("#MainContent section.listing .listing__list").innerHTML += fetchNewHTML;
                    document.querySelectorAll("#MainContent section.listing .listing__list .listing__item.hide").forEach(function (single_listing__item) {
                        single_listing__item.classList.remove("hide");
                    });

                    load_listing_script();
                    load_init_scripts_script();

                    product_grid_size_option();
                    product_grid_ATC();
                    iWish.init();
                    product_media_update();
                    check_size_option();
                    collection_pro_filter();
                    grid_metafield_product();
                    grid_option_controls();

                    if (data_current_page >= data_total_page) {
                        this.closest(".listing__more").style.display = "none";
                    }
                })
                .catch(error => {
                    console.error("Fetch error:", error);
                });
        });
    }
}

product_grid_size_option();
product_grid_ATC();
load_more_product_JS();

function careGuideCategory() {
    if (document.querySelector(".care-guide-section .care-guide")) {
        document.querySelector(".care-guide-section .care-guide select[name='category']").addEventListener("change", function () {
            var selectedOption = this.options[this.selectedIndex],
                collection_id = selectedOption.getAttribute("collection_id"),
                firstVisibleFound = false;

            document.querySelectorAll(".care-guide-section .care-guide select[name='sub-category'] option").forEach(function (singleOption) {
                if (singleOption.getAttribute("collection_id") === collection_id) {
                    singleOption.style.display = "block";
                    if (!firstVisibleFound) {
                        singleOption.selected = true;
                        firstVisibleFound = true;
                    } else {
                        singleOption.selected = false;
                    }
                } else {
                    singleOption.style.display = "none";
                    singleOption.selected = false;
                }
            });
        });

        document.querySelector(".care-guide-section .care-guide select[name='gender']").addEventListener("change", function () {
            var selectedValue = this.options[this.selectedIndex].getAttribute("data_value"),
                firstVisibleFound = false;

            document.querySelectorAll(".care-guide-section .care-guide select[name='category'] option").forEach(function (singleOption) {
                if (singleOption.getAttribute("data_gender") == selectedValue) {
                    singleOption.style.display = "block";
                    if (!firstVisibleFound) {
                        singleOption.selected = true;
                        firstVisibleFound = true;
                    } else {
                        singleOption.selected = false;
                    }
                } else {
                    singleOption.style.display = "none";
                    singleOption.selected = false;
                }
            });
            document.querySelector(".care-guide-section .care-guide select[name='category']").dispatchEvent(new Event("change", { bubbles: true }));
        });

        document.querySelectorAll(".care-guide-section .care-guide select").forEach(function (single_select) {
            single_select.addEventListener("change", function () {
                careGuidefatch();
            });
        });
    }

    if (document.querySelector(".care-guide-section .care-guide select[name='gender']")) {
        document.querySelector(".care-guide-section .care-guide select[name='gender']").dispatchEvent(new Event("change", { bubbles: true }));
    }
}

function careGuidefatch() {
    if (document.querySelector(".care-guide-section .care-guide")) {
        var product_type = document.querySelectorAll(".care-guide-section .care-guide select")[0].value,
            category = document.querySelectorAll(".care-guide-section .care-guide select")[1].value,
            sub_category = document.querySelectorAll(".care-guide-section .care-guide select")[2].value,
            new_fetch_care_guide_URL = `/collections/${category}/${sub_category}?view=care-guide&filter.p.product_type=${product_type}`;

        // console.log("new_fetch_care_guide_URL: ", new_fetch_care_guide_URL);

        fetch(new_fetch_care_guide_URL)
            .then(response => {
                return response.text();
            })
            .then(responseData => {
                var parser = new DOMParser(),
                    new_response_HTML = parser.parseFromString(responseData, "text/html"),
                    products_list = new_response_HTML.querySelector(".products-list").innerHTML,
                    product_details = new_response_HTML.querySelector(".product-details").innerHTML,
                    all_products_count = parseInt(new_response_HTML.querySelector(".products-list").getAttribute("all_products_count")),
                    page = 2;

                document.querySelector(".products-list").innerHTML = products_list;
                document.querySelector(".product-details").innerHTML = product_details;

                if (all_products_count > 50) {
                    new_fetch_care_guide_URL = `${new_fetch_care_guide_URL}&page=${page}`;

                    page_wise_product_get(new_fetch_care_guide_URL);

                    function page_wise_product_get(new_fetch_care_guide_URL) {
                        fetch(new_fetch_care_guide_URL)
                            .then(response => {
                                return response.text();
                            })
                            .then(responseData => {
                                var parser = new DOMParser(),
                                    new_response_HTML = parser.parseFromString(responseData, "text/html"),
                                    products_list = new_response_HTML.querySelector(".products-list ul").innerHTML,
                                    product_details = new_response_HTML.querySelector(".product-details").innerHTML;

                                document.querySelector(".products-list ul").insertAdjacentHTML("beforeend", products_list);
                                document.querySelector(".product-details").insertAdjacentHTML("beforeend", product_details);

                                load_misc_script();

                                if (new_response_HTML.querySelector(".product-details").innerHTML != "") {
                                    page = page + 1;
                                    new_fetch_care_guide_URL = new_fetch_care_guide_URL.replace(/page=[0-9]+/, "page=" + page);
                                    page_wise_product_get(new_fetch_care_guide_URL);
                                }
                            })
                            .catch(error => {
                                console.error("Fetch error:", error);
                            });
                    }
                }

                load_misc_script();
            })
            .catch(error => {
                console.error("Fetch error:", error);
                document.querySelector(".products-list").innerHTML = "";
                document.querySelector(".product-details").innerHTML = "";
            });
    }
}

careGuideCategory();
careGuidefatch();

function load_misc_script() {
    const script = document.createElement("script");
    script.type = "module";
    script.textContent = `
    import misc from '/cdn/shop/t/3/assets/misc.js';
    misc();
  `;
    document.body.appendChild(script);
}

function load_listing_script() {
    const script = document.createElement("script");
    script.type = "module";
    script.textContent = `
    import initListing from '/cdn/shop/t/3/assets/listing.js';
    initListing();
  `;
    document.body.appendChild(script);
}

function load_init_scripts_script() {
    const script = document.createElement("script");
    script.type = "module";
    script.textContent = `
    import initScripts from '/cdn/shop/t/3/assets/init-scripts.js';
    initScripts();
  `;
    document.body.appendChild(script);
}

function load_init_scripts_script() {
    const script = document.createElement("script");
    script.type = "module";
    script.textContent = `
    import initScripts from '/cdn/shop/t/3/assets/init-scripts.js';
    initScripts();
  `;
    document.body.appendChild(script);
}

document.querySelectorAll(".lookbook-quick-popup .js_popup").forEach(function (single_product) {
    single_product.addEventListener("click", function (event) {
        event.preventDefault();

        var popup_HTML = this.closest(".lookbook-three__item").querySelector(".popup_content_data").innerHTML;
        this.closest(".lookbook-quick-popup").querySelector(".lookbook_popup_main .popup_render_data").innerHTML = popup_HTML;
        this.closest(".lookbook-quick-popup").querySelector(".lookbook_popup_main").style.display = "flex";

        setTimeout(() => {
            product_variant_default();
            load_misc_script();
            load_listing_script();
            load_init_scripts_script();
            product_grid_size_option();
            product_grid_ATC();
            wishlist_user_login();
            iWish.init();
            check_size_option();
            default_none_option_select();
            metafield_product();
            atc_added_check();
            grid_metafield_product();
            grid_option_controls();
        }, 1000);
    });
});

document.querySelectorAll(".lookbook_popup_main .close").forEach(function (popup_close) {
    popup_close.addEventListener("click", function () {
        this.closest(".lookbook-quick-popup").querySelector(".lookbook_popup_main").style.display = "none";
        this.closest(".lookbook-quick-popup").querySelector(".lookbook_popup_main .popup_render_data").innerHTML = "";
    });
});

document.querySelectorAll(".searchbar .searchbar__btn").forEach(function (searchbar__btn) {
    searchbar__btn.addEventListener("click", function () {
        this.closest(".searchbar").querySelector(".searchbar__input").classList.toggle("searchbar__input--active");
    });
});

function wishlist_user_login() {
    document.querySelectorAll(".iWishAddColl").forEach(function (wishlistBTN) {
        wishlistBTN.addEventListener("click", function (event) {
            event.preventDefault();
            if (window.iWishData.cust == "") {
                localStorage.setItem("login", true);
                this.click();
                window.location.href = "/account/login";
            } else {
                localStorage.setItem("login", false);
            }
        });
    });
}

wishlist_user_login();

function default_none_option_select() {
    if (document.querySelector(".detail__sidebar__content .detail__sidebar__sizes .size-select__options .option.active")) {
        document.querySelector(".detail__sidebar__content .detail__sidebar__sizes .size-select__options .option.active").classList.remove("active");
    }
    if (document.querySelector(".size-select__options .option.active")) {
        document.querySelector(".size-select__options .option.active").classList.remove("active");
    }
    document.querySelectorAll(".size-select__options .option.active").forEach(function (single_active_size_option) {
        single_active_size_option.classList.remove("active");
    });
}

default_none_option_select();

window.addEventListener("load", event => {
    default_none_option_select();
});

if (document.querySelector(".customer-page .sign__form .message") && localStorage.getItem("login") == "true") {
    document.querySelector(".customer-page .sign__form .message").classList.remove("hidden");
}

function metafield_product() {
    document.querySelectorAll(".product #MainContent .meta_product_inner .meta-color-select__options .single_product:not(.active)").forEach(function (meta_color_product) {
        meta_color_product.addEventListener("click", function (event) {
            var data_handle = this.getAttribute("data_handle");

            fetch(data_handle)
                .then(response => {
                    return response.text();
                })
                .then(responseData => {
                    var parser = new DOMParser(),
                        new_response_HTML = parser.parseFromString(responseData, "text/html"),
                        MainContent_HTML = new_response_HTML.querySelector("#MainContent").innerHTML;

                    document.querySelector("#MainContent").innerHTML = MainContent_HTML;

                    product_variant_default();
                    load_misc_script();
                    load_listing_script();
                    load_init_scripts_script();
                    product_grid_size_option();
                    product_grid_ATC();
                    wishlist_user_login();
                    iWish.init();
                    product_media_update();
                    check_size_option();

                    setTimeout(() => {
                        default_none_option_select();
                    }, 500);

                    // history.replaceState({}, "", data_handle.toString());
                    history.pushState({}, "", data_handle.toString());
                    metafield_product();
                    product_mediaZoom();
                    atc_added_check();
                })
                .catch(error => {
                    console.error("Fetch error:", error);
                });
        });
    });
}

function grid_metafield_product() {
    document.querySelectorAll(".product--grid--main .meta-color-select__options .single_product:not(.active)").forEach(function (meta_color_product) {
        meta_color_product.addEventListener("click", function (event) {
            var data_handle = this.getAttribute("data_handle"),
                meta_color_product_parents = this.closest(".product--grid--main");

            fetch(data_handle)
                .then(response => {
                    return response.text();
                })
                .then(responseData => {
                    var parser = new DOMParser(),
                        new_response_HTML = parser.parseFromString(responseData, "text/html"),
                        listing__item_HTML = new_response_HTML.querySelector(".product--grid--main").innerHTML;

                    meta_color_product_parents.innerHTML = listing__item_HTML;

                    setTimeout(() => {
                        product_variant_default();
                        load_misc_script();
                        load_listing_script();
                        load_init_scripts_script();
                        product_grid_size_option();
                        product_grid_ATC();
                        wishlist_user_login();
                        iWish.init();
                        product_media_update();
                        check_size_option();
                        default_none_option_select();
                        metafield_product();
                        product_mediaZoom();
                        atc_added_check();
                        grid_metafield_product();
                        grid_option_controls();
                    }, 1000);
                })
                .catch(error => {
                    console.error("Fetch error:", error);
                });
        });
    });
}
grid_metafield_product();

function grid_option_controls() {
    document.querySelectorAll(".product--grid--main .option_control").forEach(function (option_control) {
        option_control.addEventListener("click", function (event) {
            this.classList.toggle("active");
            if (this.closest(".product--grid--main").querySelector(".hide_add_remove")) {
                this.closest(".product--grid--main").querySelector(".hide_add_remove").classList.toggle("hide");
            }
            if (this.closest(".product--grid--main").querySelector(".show_add_remove")) {
                this.closest(".product--grid--main").querySelector(".show_add_remove").classList.toggle("show");
            }
        });
    });
}
grid_option_controls();

if (document.querySelector(".product #MainContent .meta_product_inner .meta-color-select__options .single_product")) {
    window.addEventListener("popstate", function () {
        fetch(location.pathname)
            .then(response => response.text())
            .then(responseData => {
                var parser = new DOMParser(),
                    newDoc = parser.parseFromString(responseData, "text/html"),
                    newContent = newDoc.querySelector("#MainContent").innerHTML;

                document.querySelector("#MainContent").innerHTML = newContent;

                product_variant_default();
                load_misc_script();
                load_listing_script();
                load_init_scripts_script();
                product_grid_size_option();
                product_grid_ATC();
                wishlist_user_login();
                iWish.init();
                product_media_update();
                check_size_option();

                setTimeout(() => {
                    default_none_option_select();
                }, 500);

                metafield_product();
                product_mediaZoom();
                atc_added_check();
            })
            .catch(error => console.error("Popstate fetch error:", error));
    });
}

metafield_product();

if (location.href.includes("/collections/")) {
    var collection_handle = location.href.split("/collections/")[1].split("-")[0];
    localStorage.setItem("collection", collection_handle);
}

if (location.href.includes("/pages/lookbook")) {
    var lookbook_handle = location.href.split("/lookbook-")[1];
    localStorage.setItem("collection", lookbook_handle);
}

product_media_update();

function product_media_update() {
    var mens_collection = "mens",
        womens_collection = "womens";

    if (location.href.includes("category_type")) {
        var urlParams = new URLSearchParams(window.location.search),
            categoryType = urlParams.get("category_type");
        if (categoryType == mens_collection || categoryType === womens_collection) {
            localStorage.setItem("collection", categoryType);
        }
    }

    // For Product page
    if (localStorage.getItem("collection") == mens_collection) {
        document.querySelectorAll(".product .detail__sliders .swiper-slide").forEach(function (swiperSlide) {
            if (swiperSlide.getAttribute("data_alt") == womens_collection) {
                swiperSlide.remove();
            }
        });
    } else if (localStorage.getItem("collection") == womens_collection) {
        document.querySelectorAll(".product .detail__sliders .swiper-slide").forEach(function (swiperSlide) {
            if (swiperSlide.getAttribute("data_alt") == mens_collection) {
                swiperSlide.remove();
            }
        });
    }

    setTimeout(() => {
        if (document.querySelector(".product .detail__sliders__main-slider") && document.querySelector(".product .detail__sliders__thumb-slider")) {
            if (typeof document.querySelector(".product .detail__sliders__main-slider").swiper.update === "function") {
                document.querySelector(".product .detail__sliders__main-slider").swiper.update();
            }
            if (typeof document.querySelector(".product .detail__sliders__thumb-slider").swiper.update === "function") {
                document.querySelector(".product .detail__sliders__thumb-slider").swiper.update();
            }
        }
    }, 500);

    // For grid
    if (localStorage.getItem("collection") == mens_collection) {
        document.querySelectorAll(".listing__item .product-card .product-card__img-slider .swiper-slide").forEach(function (swiperSlide) {
            if (swiperSlide.getAttribute("data_alt") == womens_collection) {
                swiperSlide.remove();
            }
        });
    } else if (localStorage.getItem("collection") == womens_collection) {
        document.querySelectorAll(".listing__item .product-card .product-card__img-slider .swiper-slide").forEach(function (swiperSlide) {
            if (swiperSlide.getAttribute("data_alt") == mens_collection) {
                swiperSlide.remove();
            }
        });
    }
    setTimeout(() => {
        const product_card_img_slider = document.querySelector(".listing__item .product-card .product-card__img-product_card_img_slider");
        if (product_card_img_slider && product_card_img_slider.swiper && typeof product_card_img_slider.swiper.update === "function") {
            product_card_img_slider.swiper.update();
        }
    }, 500);

    if (document.querySelector(".cart-container .your-cart .your-cart__wrapper")) {
        document.querySelector(".cart-container .your-cart .your-cart__wrapper").setAttribute("unisex-img", localStorage.getItem("collection"));
    }
}

function product_mediaZoom() {
    if (!window.matchMedia("(pointer: coarse)").matches) {
        document.querySelectorAll(".product .zoom-element").forEach(function (zoomElem) {
            const zoom = 2.5;
            const zoomImg = zoomElem.querySelector("img");

            // Mousemove zoom logic
            zoomElem.addEventListener("mousemove", function (e) {
                if (zoomElem.classList.contains("zoom-active")) {
                    const rect = zoomElem.getBoundingClientRect(),
                        x = e.clientX - rect.left,
                        y = e.clientY - rect.top,
                        xPercent = (x / rect.width) * 100,
                        yPercent = (y / rect.height) * 100;
                    zoomImg.style.transformOrigin = `${xPercent}% ${yPercent}%`;
                    zoomImg.style.transform = `scale(${zoom})`;
                }
            });

            // Mouseleave resets zoom
            zoomElem.addEventListener("mouseleave", function () {
                zoomElem.classList.remove("zoom-active");
                zoomImg.style.transform = "scale(1)";
                zoomImg.style.transformOrigin = "center center";
            });

            // Toggle zoom on click
            zoomElem.addEventListener("click", function (event) {
                const isActive = zoomElem.classList.contains("zoom-active");

                // Remove active from all
                document.querySelectorAll(".product .zoom-element").forEach(function (elem) {
                    elem.classList.remove("zoom-active");
                    const img = elem.querySelector("img");
                    img.style.transform = "scale(1)";
                    img.style.transformOrigin = "center center";
                });

                // If it wasn't active, activate it
                if (!isActive) {
                    zoomElem.classList.add("zoom-active");
                    const get_rect = zoomElem.getBoundingClientRect(),
                        get_x = event.clientX - get_rect.left,
                        get_y = event.clientY - get_rect.top,
                        get_xPercent = (get_x / get_rect.width) * 100,
                        get_yPercent = (get_y / get_rect.height) * 100;
                    zoomImg.style.transformOrigin = `${get_xPercent}% ${get_yPercent}%`;
                    zoomImg.style.transform = `scale(${zoom})`;
                }
            });
        });
    }
}
product_mediaZoom();

function atc_added_check() {
    if (document.querySelector(".shopify-section.buy_the_look .product--grid--main .atc_JS")) {
        fetch(window.Shopify.routes.root + "cart.js", {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
            },
        })
            .then(response => {
                return response.json();
            })
            .then(responseJSON => {
                // console.log("responseJSON: ",responseJSON);
                responseJSON.items.forEach(function (item) {
                    if (document.querySelector(".shopify-section.buy_the_look .product--grid--main[data_product_id='" + item.product_id + "'] .atc_JS")) {
                        document.querySelector(".shopify-section.buy_the_look .product--grid--main[data_product_id='" + item.product_id + "'] .atc_JS").innerHTML = "Added to cart";
                    }
                });
            })
            .catch(error => {
                console.error("Error:", error);
            });
    }
}

atc_added_check();

// Cart page
function cart_event_active() {
    if (document.querySelector("#cartPage")) {
        document.querySelectorAll("#cartPage .product-row .qty_update .qty_action").forEach(function (qty_action) {
            qty_action.addEventListener("click", function () {
                var qtyContainer = this.closest(".qty_update"),
                    qtyInput = qtyContainer.querySelector("input"),
                    qtyValue = parseInt(qtyInput.value);

                if (this.classList.contains("qty_plus")) {
                    qtyValue += 1;
                    qtyInput.value = qtyValue;
                } else if (this.classList.contains("qty_minus")) {
                    if (qtyValue > 1) {
                        qtyValue -= 1;
                        qtyInput.value = qtyValue;
                    }
                }
                qtyInput.dispatchEvent(new Event("change", { bubbles: true }));
            });
        });

        document.querySelectorAll("#cartPage .product-row .qty_update .quantity__input").forEach(function (quantity__input) {
            quantity__input.addEventListener("change", function () {
                var item_variant_id = parseInt(this.closest(".product-row").getAttribute("item_variant_id")),
                    qtyValue = parseInt(quantity__input.value);
                cart_qty_update(item_variant_id, qtyValue);
            });
        });

        document.querySelectorAll("#cartPage .product-row .remove_item").forEach(function (remove_item) {
            remove_item.addEventListener("click", function () {
                var item_variant_id = parseInt(this.closest(".product-row").getAttribute("item_variant_id"));
                cart_qty_update(item_variant_id, 0);
            });
        });
    }
}

function cart_qty_update(id, qty) {
    let updates = { [id]: qty };
    fetch(window.Shopify.routes.root + "cart/update.js", {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify({ updates }),
    })
        .then(response => {
            return response.json();
        })
        .then(cartResponse => {
            // console.log("call", cartResponse);
            cart_update();
        })
        .catch(error => {
            console.error("Error:", error);
        });
}

function cart_update() {
    fetch(window.Shopify.routes.root + "cart")
        .then(response => response.text())
        .then(html => {
            const parser = new DOMParser();
            const doc = parser.parseFromString(html, "text/html");
            const newCartContent = doc.querySelector("#cartPage");
            if (newCartContent) {
                document.querySelector("#cartPage").innerHTML = newCartContent.innerHTML;
            }
            load_misc_script();
            setTimeout(() => {
              cart_event_active();
            }, 1500);
        })
        .catch(error => {
            console.error("Failed to update cart HTML:", error);
        });
}
cart_event_active();

window.addEventListener("load", event => {
   setTimeout(() => {
    cart_event_active();
  }, 2000);
});

var change_coockie_link = setInterval(change_link, 1000);
function change_link() {
    var old_link = document.querySelector("#shopify-pc__banner__body-policy-link");
    if (old_link) {
        old_link.setAttribute("href", "/pages/privacy-policy");
        clearInterval(change_coockie_link);
    }
}

function custom_category_filter(_this) {
    var categoryURL = _this.getAttribute("redirect-url");
    if (document.querySelector("#secondary-view-button")) {
        document.querySelector("#secondary-view-button").setAttribute("redirect-url", categoryURL);
    }
}

function redirect_to_category(_this) {
    if (_this.hasAttribute("redirect-url")) {
        location.href = _this.getAttribute("redirect-url");
    }
}
